// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LNDL","badges":"styles_badges__2RhUO"};